<div class="no-results" [class]="HEIGHT_CLASS_MAPPING[height]">
  <i phx-icon [phxIcon]="icon" [color]="iconColor" [size]="iconSize"></i>
  <div>{{message}}</div>
</div>